const HIDDEN_CLASS = 'odf-hidden';
const SELECTOR_WRAPPER_CLASS = '.baggage_selector_wrapper';
const DUMMY_TEMPLATE = Odigeo._.template();

const formatOptions = (options, isExtraBag, shouldSplitPrice, keys) => {
    return options.reduce((acc, option) => {
        const pieces = isExtraBag ? option.get('piecesToShow') : option.get('pieces');
        let price = option.get('price');
        let primePrice = option.get('primePrice');
        let kilos = Odigeo.AB.isDisplayTotalBaggageWeightAllowance ? option.get('kilos') : option.get('kilosPerPiece');
        let isSelectableOption = price !== 0 && pieces > 0;
        price = price > 0 && shouldSplitPrice ? price/2 : price;
        primePrice = primePrice > 0 && shouldSplitPrice ? primePrice/2 : primePrice;

        kilos = !Odigeo._.isUndefined(kilos) && kilos > 0 ? kilos : undefined;
        const conceptWithWeight = Odigeo.AB.isDisplayTotalBaggageWeightAllowance && pieces > 1 ?
            keys.dropdownPiecesWithTotalKilos : keys.dropdownPiecesWithkilos;
        const conceptWithWeightExtra = Odigeo.AB.isDisplayTotalBaggageWeightAllowance ?
            keys.dropdownExtraPiecesWithTotalKilos : keys.dropdownExtraPiecesWithKilos;
        const concept = !Odigeo._.isUndefined(kilos) ?
            (isExtraBag ? conceptWithWeightExtra : conceptWithWeight)
            : (isExtraBag ? keys.dropdownExtraPieces : keys.dropdownPieces);
        const conceptLabel = Odigeo.Utils.pluralizeAll(concept, pieces, kilos);
        return [...acc, {
            isSelectableOption,
            id: option.cid,
            price,
            primePrice,
            pieces,
            conceptLabel,
            formattedPrice: Odigeo.Utils.formatCurrency(price),
            formattedPrimePrice: Odigeo.Utils.formatCurrency(primePrice),
            kilos,
        }];
    }, []);
};

class UIStrategy {
    constructor($selectorWrapper, ancillaryContainer, templates, keys, primeInfo) {
        this.$selectorWrapper = $selectorWrapper;
        this.ancillaryContainer = ancillaryContainer;
        this.primeInfo = primeInfo;
        this.templates = {
            list: DUMMY_TEMPLATE,
            wrapper: DUMMY_TEMPLATE,
        };

        this.keys = keys;
    }

    getSelectedBaggageData(evt) {
        return null;
    }

    toggle(parent, hide) {
        const $wrapper = this.$selectorWrapper.find(SELECTOR_WRAPPER_CLASS);
        $wrapper.toggleClass(HIDDEN_CLASS, hide);
    }

    getWrapperData() {
        return {
            keys: this.keys,
        };
    }

    getSelectorData(data = {}) {
        const {isPrimeView} = this.primeInfo;
        const isExtraBag = data.offerAdditionalBaggage;
        const isDisplayTotalBaggageWeightAllowance = Odigeo.AB.isDisplayTotalBaggageWeightAllowance;
        const shouldSplitPrice = data.shouldSplitPrice;
        const rowCollectionId = data.rowCollectionId;
        const noAddOption = isExtraBag ? this.keys.dropdownNoExtra : this.keys.noInclude;
        const primePriceTag = this.keys.bagsSelectorPrimePriceTag;
        const options = data.options;
        const zeroOptionId = Odigeo._.get(Odigeo._.find(options, (option) => option.get('pieces') === 0), 'cid');
        const optionsFormatted = formatOptions(options, isExtraBag, shouldSplitPrice, this.keys);
        const priceApplicationLevelLabel = shouldSplitPrice ? this.keys.dropdownPriceFlight : '';
        const bagsSelectorPrimePriceTagPricePerFlight = shouldSplitPrice ? this.keys.bagsSelectorPrimePriceTagPricePerFlight : '';

        return {
            noAddOption,
            zeroOptionId,
            rowCollectionId,
            priceApplicationLevelLabel,
            bagsSelectorPrimePriceTagPricePerFlight,
            isExtraBag,
            primePriceTag,
            isDisplayTotalBaggageWeightAllowance,
            options: optionsFormatted,
            isPrimeView,
        };
    }
}

module.exports = UIStrategy;
